import { Injectable } from '@angular/core';
import { PageHeadingResolver, SearchPageMetaResolver } from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class CustomSearchPageMetaResolver
  extends SearchPageMetaResolver
  implements PageHeadingResolver
{
  resolveHeading(): Observable<string | undefined> {
    return of('');
  }
}
